import { createContext, useEffect, useState } from "react";

export const GlobalContext = createContext();

const GlobalContextProvider = (props) => {

  return (
    <GlobalContext.Provider
      value={{
        data:{
          "email": "user1@plaidware.com",
          "password": "123456789",
          "firstName": "User",
          "lastName": "One"
        },
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
export default GlobalContextProvider;
